<ng-container *ngIf="isMobile;then mobile else desktop"></ng-container>


<ng-template #desktop>
    <div class="left">
        <app-button
            *ngIf="notMainPath"
            (clicked)="onGoBack()"
            type="primary"
            class="back-button">
            {{ 'generic.buttons.back' | translate }}
        </app-button>
        <app-language-picker></app-language-picker>

        <app-dropdown-multiple *ngIf="hasPlantDropdown && allPlants?.length"
                               [items]="allPlants"
                               [placeholder]="'selectPlants' | translate"
                               [(ngModel)]="desktopAdaptedPlants"
                               (selection)="onPlantsSelected($event)"
                               emptyText="{{ 'generic.multipleDropdown.emptyMessage' | translate }}">
        </app-dropdown-multiple>
        <app-dropdown-multiple
            *ngIf="showSectionSelector"
            [items]="availableSidebarItems"
            [(ngModel)]="selectedSidebarItemObjects"
            (selection)="onSidebarObjectsSelected($event)"
            [placeholder]="'selectSidebarItems' | translate"
            emptyText="{{ 'generic.multipleDropdown.emptyMessage' | translate }}">
        </app-dropdown-multiple>
    </div>

    <a class="center" routerLink="/">
        <img class="logo" src="../../../../assets/images/atom_v1_logo.png"/>
    </a>

    <div class="right">
        <app-dropdown *ngIf="availableRoles.length > 1"
                      [items]="availableRoles"
                      [ngModel]="selectedRoleId"
                      [displayField]="'label'"
                      [valueField]="'id'"
                      [isDisabled]="isRoleSwitchInProgress"
                      emptyText="Select role"
                      (selectItem)="onRoleSelected($event)">
        </app-dropdown>
        <span>{{ currentUser?.sub }}</span>
        <app-button class="btn btn-primary logout-button" (click)="logout()">
            {{ 'generic.buttons.logout' | translate }}
        </app-button>
    </div>
</ng-template>

<ng-template #mobile>
    <!-- Mobile Hamburger Button -->
    <div class="hamburger">
        <app-icon library="fontawesome" variant="fa-bars" class="hamburger-button"
                  (click)="showSidebar()">
        </app-icon>
    </div>

    <div class="left">
        <app-button
            *ngIf="notMainPath && !mobile"
            (clicked)="onGoBack()"
            type="primary"
            class="back-button">
            {{ 'generic.buttons.back' | translate }}
        </app-button>

        <app-dropdown-multiple *ngIf="hasPlantDropdown && allPlants?.length && !isMobile"
                               [items]="allPlants"
                               [placeholder]="'selectPlants' | translate"
                               [(ngModel)]="desktopAdaptedPlants"
                               (selection)="onPlantsSelected($event)"
                               emptyText="{{ 'generic.multipleDropdown.emptyMessage' | translate }}">
        </app-dropdown-multiple>
        <app-dropdown-multiple
            *ngIf="showSectionSelector"
            [items]="availableSidebarItems"
            [(ngModel)]="selectedSidebarItemObjects"
            (selection)="onSidebarObjectsSelected($event)"
            [placeholder]="'selectSidebarItems' | translate"
            emptyText="{{ 'generic.multipleDropdown.emptyMessage' | translate }}">
        </app-dropdown-multiple>
    </div>

    <a class="center" routerLink="/">
        <img class="logo" src="../../../../assets/images/atom_v1_logo.png"/>
    </a>

    <div class="kebab">
        <app-icon library="fontawesome"
                  variant="fa-ellipsis-v"
                  (click)="toggleKebabMenu($event, menu)">
        </app-icon>
        <!-- Kebab Menu -->
        <p-menu #menu [model]="kebabMenuItems" [popup]="true" (onHide)="onHide()"></p-menu>
    </div>

    <!-- PrimeNG Sidebar for the mobile menu -->
    <p-sidebar class="sidebar"
               [(visible)]="mobile && visibleSidebar"
               position="left">
        <ng-template pTemplate="header">
            <span class="name">{{ currentUser?.sub }}</span>
            <app-dropdown *ngIf="availableRoles.length > 1"
                          [items]="availableRoles"
                          [ngModel]="selectedRoleId"
                          [displayField]="'label'"
                          [valueField]="'id'"
                          [isDisabled]="isRoleSwitchInProgress"
                          emptyText="Select role"
                          (selectItem)="onRoleSelected($event)">
            </app-dropdown>
        </ng-template>
        <ul class="menu" [ngSwitch]="currentUser.role">
            <ng-container *ngSwitchCase="'ATOM_Storage'">
                <!-- Process tool requests -->
                <ng-container *ngIf="hasSection('PROCESS_TOOL_REQUESTS_SECTION')">
                    <ng-container *ngTemplateOutlet="processToolRequests"></ng-container>
                </ng-container>
                <!-- Process tool requests -->
                <ng-container *ngIf="hasSection('PROCESS_TOOL_RETURNS_SECTION')">
                    <ng-container *ngTemplateOutlet="processToolReturns"></ng-container>
                </ng-container>
            </ng-container>
        </ul>
        <ul class="menu">
            <li class="logout">
                <a class="list-item"
                   (click)="logout()">
                    <app-icon [simple]="true" type="white" library="fontawesome" variant="fa-sign-out"></app-icon>
                    <span>{{ 'generic.buttons.logout' | translate }}</span>
                </a>
            </li>
        </ul>
    </p-sidebar>

</ng-template>


<ng-template #processToolRequests>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">build</i>
            <span>{{ 'nav.sections.process-tool-requests.title' | translate }}</span>
        </div>
    </li>
    <!-- Here -->
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_REQUESTS')">
        <a routerLink="/incoming-tool-requests/lines" class="list-item"
           (click)="onLinkClick($event)">
            <span
                *ngIf="missedNotifications?.toolRequests?.processLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.processLineRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tool-requests/lines')
                && !missedNotifications?.toolRequests?.processLineRequests && processLineToolRequests > 0"
                class="requests-counter">
                    {{ processLineToolRequests }}
            </span>
            <i class="fa fa-download"></i>
            <span>{{ 'nav.sections.process-tool-requests.items.processLines' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_REQUESTS')">
        <a routerLink="/incoming-tool-requests/facilities" class="list-item"
           (click)="onLinkClick($event)">
            <span
                *ngIf="missedNotifications?.toolRequests?.processFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolRequests?.processFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tool-requests/facilities')"
                class="requests-counter">
                    {{ processFacilityToolRequests }}
            </span>
            <i class="fa fa-cloud-download"></i>
            <span>{{ 'nav.sections.process-tool-requests.items.processFacilities' | translate }}</span>
        </a>
    </li>
</ng-template>

<ng-template #processToolReturns>
    <li>
        <div class="side-nav-category list-item">
            <i class="material-icons">build</i>
            <span>{{ 'nav.sections.process-tool-returns.title' | translate }}</span>
        </div>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_RETURNS')">
        <a routerLink="/incoming-tools-returned/lines" class="list-item"
           (click)="onLinkClick($event)">
            <span
                *ngIf="missedNotifications?.toolReturns?.processLineRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.processLineRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tools-returned/lines')
                && !missedNotifications?.toolReturns?.processLineRequests && processLineToolReturns > 0"
                class="requests-counter">
                    {{ processLineToolReturns }}
            </span>
            <i class="fa fa-upload"></i>
            <span>{{ 'nav.sections.process-tool-returns.items.processLines' | translate }}</span>
        </a>
    </li>
    <li routerLinkActive="active"
        *ngIf="hasPermission('PROCESS_TOOL_RETURNS')">
        <a routerLink="/incoming-tools-returned/facilities" class="list-item"
           (click)="onLinkClick($event)">
            <span
                *ngIf="missedNotifications?.toolReturns?.processFacilityRequests > 0"
                class="requests-counter requests-counter--offline">
                    {{ missedNotifications?.toolReturns?.processFacilityRequests }}
            </span>
            <span
                *ngIf="visitedUrls.get('/incoming-tools-returned/facilities')"
                class="requests-counter">
                    {{ processFacilityToolReturns }}
            </span>
            <i class="fa fa-cloud-upload"></i>
            <span>{{ 'nav.sections.process-tool-returns.items.processFacilities' | translate }}</span>
        </a>
    </li>
</ng-template>
